<template>
  <base-page-layout title="Gerais">
    <v-container fluid class="compartilhamento px-0">
      <points-configuration v-if="$getAllowedModules()['points']" />
      <contacts-table />
    </v-container>
  </base-page-layout>
</template>

<script>
import BasePageLayout from '@/components/BasePageLayout.vue'
import ContactsTable from '@/modules/configuracoes/gerais/views/components/ContactsTable.vue'
import PointsConfiguration from '@/modules/configuracoes/gerais/views/components/PointsConfiguration.vue'

export default {
  name: 'Compartilhamento',
  components: {
    BasePageLayout,
    ContactsTable,
    PointsConfiguration,
  },
  data: () => ({
    loader: false,
  }),
}
</script>

<style lang="scss">
.compartilhamento {
  .compartilhamento-title {
    font-weight: bold;
    font-size: 26px;
    color: $cinza-d10;
    line-height: 120%;
    margin: 10px 0 0 0;
  }

  .info-text {
    font-size: 16px;
  }

  .status-text {
    font-size: 14px;
  }

  .btn-accept {
    font-size: 16px;
  }

  p {
    line-height: 150%;
    color: $cinza-0;
  }
}
</style>
